module.exports = __webpack_public_path__ + "static/media/20180905_174029.a5ee7d49.jpg";